import styled from 'styled-components';

export const Button = styled.button`
  cursor: pointer;
  border: none;
  -webkit-appearance: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: white;
  background: #4e4e4e;
  border-radius: 30px;
  font-size: 1.7rem;
  width: 140px;
  height: 50px;
  &:focus {
    outline: none;
  }

  ${({ secondary }) =>
    secondary &&
    `
		background: #ECEAE0;
	`}

  &:hover {
    color: white;
    background: #efaa7c;
`;
